<div class="survey-snack-bar" cdkTrapFocus>
  <div class="header">
    <ng-content select="[title]"></ng-content>
  </div>
  <div [formGroup]="form" #content>
    <ng-content select="[description]"></ng-content>

    <div class="star-rating-container">
      <mat-radio-group formControlName="rating" class="star-rating" #firstFocusableElement>
        @for (star of [1, 2, 3, 4, 5]; track star) {
          <mat-radio-button
            [value]="star"
            (mouseover)="hoveredRating=star"
            (mouseleave)="hoveredRating=null"
            class="star"
            aria-describedby="feedback-description"
            [ngClass]="{'filled': hoveredRating ? star <= hoveredRating : star <= form.value.rating}">
            <i class="ficon-pointy-star"></i>
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (form.controls.rating.touched && form.controls.rating.hasError('required')) {
        <mat-error
          translate="customer-feedback-rating-required">
        </mat-error>
      }
    </div>

    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label translate="customer-feedback-more"></mat-label>
      <textarea matInput formControlName="feedback"></textarea>
    </mat-form-field>
  </div>
  <div class="action-wrapper">
    @if (hasProjectedContent) {
      <ng-content></ng-content>
    } @else {
      <button
        class="tertiary-btn no-thanks"
        (click)="close.emit()"
        translate="common_no-thanks">
      </button>
      <button
        class="tertiary-btn snooze"
        (click)="close.emit(true)"
        translate="common_snooze">
      </button>
    }


    <button
      class="primary-btn submit-btn"
      [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
      (click)="submit.emit()"
      translate>
      common_submit
    </button>
  </div>
</div>
